import React, { useEffect } from 'react';
import { Device } from 'DeviceUtils';
import { Image as I } from 'react-native';

const Image = (props) => {
    const { source } = props;
    return <I {...props} defaultSource={source} />;
};
const ImageComponent = Device.isWeb ? Image : require('react-native-fast-image');

/**
 * @param {import('react-native-fast-image').FastImageProperties} props
 */
export const CachedImage = (props) => {
    const newProps = { ...props };
    useEffect(() => {
        if (!Device.isWeb && newProps?.source && newProps?.source?.uri) {
            newProps.source.cache = ImageComponent.cacheControl.web;
        }
    }, []);
    return <ImageComponent {...newProps} />;
};
